import { render, staticRenderFns } from "./Citation.vue?vue&type=template&id=8f1713d6&scoped=true"
import script from "./Citation.vue?vue&type=script&lang=js"
export * from "./Citation.vue?vue&type=script&lang=js"
import style0 from "./Citation.vue?vue&type=style&index=0&id=8f1713d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1713d6",
  null
  
)

export default component.exports